import { Category } from '@/modules/plan/PlanSetup/EligibleServicesSection/EligibleServices.types';
import { storeCreator } from '@/utils/store/store.utils';

interface State {
  modalVisible: boolean;
  categories: Category[];
  isSubmitted: boolean;

  handleChangeVisibility: (value: boolean) => void;
  handleSetCategories: (value: Category[]) => void;
  handleSetIsSubmitted: (value: boolean) => void;
  handleReset: () => void;
}

export const useSpendLimitsModalStore = storeCreator<State>((set) => ({
  modalVisible: false,
  categories: [],
  isSubmitted: false,

  handleChangeVisibility: (value) => set((state) => ({ ...state, modalVisible: value })),
  handleSetCategories: (value) => set((state) => ({ ...state, categories: value })),
  handleSetIsSubmitted: (value) => set((state) => ({ ...state, isSubmitted: value })),
  handleReset: () => set((state) => ({
    ...state,
    modalVisible: false,
    isSubmitted: false,
  })),
}));
